import React, { useState } from 'react';

const CloseCircleIcon = ({
  onClick,
  color = '#e57373',
  hoverColor = '#e60b0b',
  size = 27,
  iconSize = 18,
  style = {},
  ...props
}) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        backgroundColor: hover ? hoverColor : color,
        borderRadius: '50%',
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        width: size,
        height: size,
        transition: 'background-color 0.3s ease',
        ...style,
      }}
      {...props}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </div>
  );
};

export default CloseCircleIcon;
